// ============================================
// ADS Uzmanı - Blog Content
// ============================================

import { BlogContent } from '../../types';

export const adsUzmaniContent: BlogContent = {
  tableOfContents: [
    { id: "uzman-kimdir", title: "ADS Uzmanı Kimdir?" },
    { id: "yetenekler", title: "Gerekli Yetenekler" },
    { id: "sertifikalar", title: "Sertifikalar" },
    { id: "secim-sureci", title: "Seçim Süreci" },
    { id: "maliyet-analizi", title: "Maliyet Analizi" },
    { id: "sss", title: "Sık Sorulan Sorular" }
  ],
  content: [
    {
      type: "paragraph",
      value: "<strong>ADS uzmanı</strong> arıyorsanız, 18 yıllık deneyimli uzman olarak seçim kriterlerini ve dikkat edilmesi gereken noktaları detaylıyla paylaşıyorum."
    },
    { type: "heading", value: "ADS Uzmanı Kimdir?", id: "uzman-kimdir" },
    {
      type: "list",
      items: [
        "<strong>5+ Yıl Deneyim:</strong> En az 5 yıl aktif kampanya yönetimi",
        "<strong>Google Sertifikaları:</strong> Tüm Google Ads sertifikaları güncel",
        "<strong>Kanıtlanmış Başarılar:</strong> Referanslar ve case study'ler",
        "<strong>İletişim:</strong> Hızlı yanıt ve şeffaf raporlama"
      ]
    },
    { type: "heading", value: "Gerekli Yetenekler", id: "yetenekler" },
    {
      type: "paragraph",
      value: "Başarılı bir <strong>ADS uzmanı</strong> olmak için hem teknik hem de analitik yeteneklere sahip olmak gerekir:"
    },
    {
      type: "list",
      items: [
        "<strong>Google Ads Platform Hakimiyeti:</strong> Tüm kampanya türlerinde uzman seviye bilgi",
        "<strong>Analitik Düşünme:</strong> Veri yorumlama ve stratejik karar alma becerisi",
        "<strong>Stratejik Planlama:</strong> Uzun vadeli kampanya stratejileri geliştirme",
        "<strong>Sürekli Öğrenme:</strong> Platform güncellemelerini takip etme ve adapte olma",
        "<strong>İletişim Becerileri:</strong> Müşteri raporlama ve beklenti yönetimi",
        "<strong>Problem Çözme:</strong> Kampanya sorunlarını hızlıca tespit edip çözme"
      ]
    },
    {
      type: "table",
      caption: "ADS Uzmanı Deneyim Seviyeleri",
      headers: ["Seviye", "Deneyim", "Yönetilen Bütçe", "Aylık Ücret"],
      rows: [
        ["<strong>Junior</strong>", "1-2 yıl", "10.000-30.000₺", "6.000-8.000₺"],
        ["<strong>Mid-Level</strong>", "3-5 yıl", "30.000-75.000₺", "10.000-15.000₺"],
        ["<strong>Senior</strong>", "6-10 yıl", "75.000-150.000₺", "18.000-25.000₺"],
        ["<strong>Expert</strong>", "10+ yıl", "150.000₺+", "30.000₺+"]
      ]
    },
    { type: "heading", value: "Sertifikalar", id: "sertifikalar" },
    {
      type: "paragraph",
      value: "Profesyonel <strong>ADS uzmanı</strong> seçerken sertifikalara dikkat edin. Google Ads sertifikaları, uzmanın platform bilgisini ve güncelliğini gösterir:"
    },
    {
      type: "list",
      items: [
        "<strong>Google Ads Arama Sertifikası:</strong> Arama kampanyaları uzmanlığı",
        "<strong>Google Ads Display Sertifikası:</strong> Display network bilgisi",
        "<strong>Google Ads Video Sertifikası:</strong> YouTube reklam yönetimi",
        "<strong>Google Ads Shopping Sertifikası:</strong> E-ticaret kampanyaları",
        "<strong>Google Analytics Sertifikası:</strong> Veri analizi yetkinliği",
        "<strong>Google Tag Manager:</strong> Takip kodu yönetimi"
      ]
    },
    {
      type: "paragraph",
      value: "Daha fazla bilgi için <a href=\"https://skillshop.withgoogle.com\" rel=\"nofollow\" target=\"_blank\" class=\"text-[#059669] hover:underline\">Google Skillshop</a>, <a href=\"https://support.google.com/google-ads\" rel=\"nofollow\" target=\"_blank\" class=\"text-[#059669] hover:underline\">Google Ads Destek</a> ve <a href=\"https://www.google.com/partners/\" rel=\"nofollow\" target=\"_blank\" class=\"text-[#059669] hover:underline\">Google Partners</a> kaynaklarını inceleyebilirsiniz."
    },
    { type: "heading", value: "Seçim Süreci", id: "secim-sureci" },
    {
      type: "paragraph",
      value: "<strong>ADS uzmanı</strong> seçerken izlemeniz gereken adımlar:"
    },
    {
      type: "list",
      items: [
        "<strong>Portföy İncelemesi:</strong> Önceki projeleri ve başarı oranlarını kontrol edin",
        "<strong>Referans Kontrolü:</strong> Eski müşterilerle iletişime geçin",
        "<strong>Sertifika Doğrulama:</strong> Google sertifikalarının geçerliliğini teyit edin",
        "<strong>Deneme Süreci:</strong> 1-3 aylık deneme dönemi talep edin",
        "<strong>Raporlama Sistemi:</strong> Düzenli raporlama ve şeffaflık konusunda anlaşın"
      ]
    },
    {
      type: "paragraph",
      value: "Profesyonel <a href=\"/blog/google-ads-reklam-uzmani\" class=\"text-[#059669] hover:underline\">Google Ads reklam uzmanı</a> ile çalışarak kampanyalarınızı maksimum verimlilikle yönetebilirsiniz."
    },
    { type: "heading", value: "Maliyet Analizi", id: "maliyet-analizi" },
    {
      type: "paragraph",
      value: "<strong>ADS uzmanı</strong> maliyetleri, deneyim seviyesine ve hizmet kapsamına göre değişir. İşte 2025 piyasa fiyatları:"
    },
    {
      type: "list",
      items: [
        "<strong>Freelance Uzman:</strong> 8.000₺ - 25.000₺/ay (bütçeye göre değişir)",
        "<strong>Ajans Hizmeti:</strong> 15.000₺ - 50.000₺/ay (daha kapsamlı destek)",
        "<strong>Full-Time Çalışan:</strong> 40.000₺ - 80.000₺/ay (maaş + yan haklar)",
        "<strong>Proje Bazlı:</strong> 25.000₺ - 100.000₺ (tek seferlik kurulum)"
      ]
    },
    {
      type: "paragraph",
      value: "Ortalama olarak, profesyonel uzman ile çalışan işletmeler %300-500 ROI artışı elde ediyor. Bu da yatırımın kendini 2-3 ay içinde amorti ettiği anlamına gelir."
    },
    { type: "heading", value: "Sık Sorulan Sorular", id: "sss" },
    {
      type: "subheading",
      value: "ADS uzmanı ne kadar kazanır?"
    },
    {
      type: "paragraph",
      value: "ADS uzmanlarının geliri deneyime göre değişir. Junior uzmanlar 30.000-50.000₺, mid-level uzmanlar 50.000-100.000₺, senior uzmanlar 100.000-200.000₺ aylık gelir elde eder. Freelance çalışan uzmanlar daha yüksek saatlik ücret alabilir."
    },
    {
      type: "subheading",
      value: "ADS uzmanı olmak için ne gerekir?"
    },
    {
      type: "paragraph",
      value: "Dijital pazarlama eğitimi, Google Ads sertifikaları, en az 2-3 yıl deneyim, analitik düşünme becerisi ve sürekli öğrenme istekliliği gerekir. Portföy ve referanslar da önemlidir."
    },
    {
      type: "subheading",
      value: "Uzman mı ajans mı tercih etmeliyim?"
    },
    {
      type: "paragraph",
      value: "15.000-75.000₺ aylık bütçe için bireysel uzman daha uygun maliyetli ve kişiselleştirilmiş hizmet sunar. 75.000₺+ bütçeler için ajans, ekip desteği ve entegre hizmetler sağlar."
    },
    {
      type: "subheading",
      value: "ADS uzmanı sertifikaları ne kadar önemli?"
    },
    {
      type: "paragraph",
      value: "Sertifikalar, uzmanın güncel bilgiye sahip olduğunu ve Google standartlarını karşıladığını gösterir. Ancak deneyim ve sonuçlar daha önemlidir. Sertifikalı ama deneyimsiz uzmanlardan kaçının."
    },
    {
      type: "subheading",
      value: "Uzman değiştirme süreci nasıl işler?"
    },
    {
      type: "paragraph",
      value: "Mevcut kampanyalarınızı yeni uzmana devretmek 1-2 hafta sürer. Geçiş döneminde hesap erişimleri ve raporları paylaşılır. Minimum 3 aylık çalışma önerilir çünkü ilk ay adaptasyon dönemidir."
    },
    {
      type: "paragraph",
      value: "<strong>Sonuç olarak</strong>, doğru ADS uzmanı seçimi dijital pazarlama başarınızın temelidir. Deneyim, sertifikalar, referanslar ve iletişim becerilerini değerlendirerek bilinçli karar verin."
    }
  ]
};

export default adsUzmaniContent;
